import { Search } from "lucide-react"
import { useTranslation } from "react-i18next"

import { Label } from "../ui/label"
import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarInput,
  useSidebar,
} from "../ui/sidebar"

export function SearchForm({ ...props }) {
  const { t } = useTranslation("common")
  const { state } = useSidebar()

  // Hide search form when sidebar is collapsed to prevent overflow
  if (state === "collapsed") {
    return null
  }

  return (
    <form {...props}>
      <SidebarGroup className="py-0">
        <SidebarGroupContent className="relative">
          <Label htmlFor="search" className="sr-only">
            {t("placeholder.Search") || "Search"}
          </Label>
          <SidebarInput
            id="search"
            placeholder={t("placeholder.Search") || "Search..."}
            className="pl-8"
          />
          <Search className="pointer-events-none absolute left-2 top-1/2 size-4 -translate-y-1/2 select-none opacity-50" />
        </SidebarGroupContent>
      </SidebarGroup>
    </form>
  )
}
